module.exports = __webpack_public_path__ + "img/singletrack-study-change.7c015784.png";